import React from "react";
import { subTitle, footer } from "../Shared/Styles";
import { formatDate } from "./ProductDetails";

export default function Footer(props) {
  var isBTLife =
    props.policyOrigin !== undefined && props.policyOrigin === "TLIS";

  if (props.productDetails !== undefined && props.policyDetails !== undefined) {
    return (
      <div>
        {!isBTLife && (
          <>
            <p
              style={{
                footer,
                subTitle,
              }}
            >
              <em>
                Your policy may have other options connected to your benefits
                which are not listed in this document. For full details, please
                refer to your most recent policy schedule.
              </em>
            </p>

            <p
              style={{
                textAlign: "justify",
                footer,
                marginLeft: "0px",
                fontWeight: "bold",
              }}
            >
              This document confirms that the above policy is current and paid
              until {formatDate(props.productDetails[0].nextBillDate)}, subject
              to all payments being cleared by your financial institution.
            </p>
          </>
        )}

        {(props.productDetails[0].brandName === null ||
          props.productDetails[0].brandName === "TAL") && (
          <p
            style={{
              footer,
              subTitle,
            }}
          >
            If you have any questions please call the Customer Service Centre on
            1300 209 088, Monday to Friday, 8am - 7pm (AEST). Alternately, you
            can email customerservice@tal.com.au quoting Policy Number{" "}
            {props.policyDetails[0].policyNumber}
          </p>
        )}

        {["BT", "STG", "WFS"].includes(props.productDetails[0].brandCode) && (
          <footer>
            <p style={{ textAlign: "justify", marginTop: "40px" }}>
              The insurer and issuer is TAL Life Limited ABN 70 050 109 450 AFSL
              237848 (TAL Life) except for Term Life as Superannuation, Income
              Protection as Superannuation and Income Protection Assured as
              Superannuation, which are issued by Mercer Superannuation
              (Australia) Limited ABN 79 004 717 533 AFSL 235906 (MSAL) as
              trustee of the Mercer Super Trust ABN 19 905 422 981. MSAL does
              not guarantee the insurance. TAL is part of the TAL Dai-ichi Life
              Australia Pty Limited ABN 97 150 070 483 group of companies (TAL).
              MSAL is not part of the TAL group of companies. Any financial
              product advice is general in nature only and does not take into
              account any person’s objectives, financial situation or needs.
              Before acting on it, the appropriateness of the advice for any
              person should be considered, having regard to those factors.
              Persons deciding whether to acquire or continue to hold life
              insurance issued by TAL Life should consider the relevant Product
              Disclosure Statement (PDS) available at tal.com.au. The Target
              Market Determination (TMD) for the product (where applicable) is
              also available at this web address.
            </p>
          </footer>
        )}

        {props.productDetails[0].brandCode === "ASTN" && (
          <p
            style={{
              footer,
              subTitle,
            }}
          >
            If you have questions about the information in your Certificate of
            Currency, please call us on 1800 221 727, Monday to Friday, 8.00 am
            to 6.00 pm (AEST).
          </p>
        )}

        {props.productDetails[0].brandCode === "ASTN" &&
          ((props.productDetails[0].taxType !== null &&
            props.productDetails[0].taxType === "Ordinary") ||
            (props.productDetails[0].taxType !== null &&
              props.productDetails[0].taxType === "External Trustee")) && (
            <footer>
              <p style={{ textAlign: "justify", marginTop: "40px" }}>
                TAL Life Limited ABN 70 050 109 450 AFSL 237848 (TAL Life) is
                part of the TAL Dai-ichi Life Australia Pty Limited ABN 97 150
                070 483 group of companies (TAL). The different entities of TAL
                group of companies are not responsible for, or liable in respect
                of, products and services provided by the other.{" "}
              </p>
            </footer>
          )}

        {props.productDetails[0].brandCode === "SUN" && (
          <p
            style={{
              footer,
              subTitle,
            }}
          >
            If you have questions about the information in your Certificate of
            Currency, please call us on 1800 030 733, Monday to Friday, 8.00 am
            to 6.00 pm (AEST).
          </p>
        )}

        {props.productDetails[0].brandCode === "SUN" &&
          ((props.productDetails[0].taxType !== null &&
            props.productDetails[0].taxType === "Ordinary") ||
            (props.productDetails[0].taxType !== null &&
              props.productDetails[0].taxType === "External Trustee")) && (
            <footer>
              <p style={{ textAlign: "justify", marginTop: "40px" }}>
                TAL Life Limited ABN 70 050 109 450 AFSL 237848 (TAL Life) is
                part of the TAL Dai-ichi Life Australia Pty Limited ABN 97 150
                070 483 group of companies (TAL). The different entities of TAL
                and the Suncorp Group Limited ABN 66 145 290 124 group of
                companies are not responsible for, or liable in respect of,
                products and services provided by the other. TAL companies are
                not part of the Suncorp Group. TAL Life uses the Suncorp brand
                under licence from the Suncorp Group.{" "}
              </p>
            </footer>
          )}

        {(props.productDetails[0].brandCode === "ASTN" ||
          props.productDetails[0].brandCode === "SUN") &&
          props.productDetails[0].taxType !== null &&
          props.productDetails[0].taxType !== "Ordinary" &&
          props.productDetails[0].taxType !== "External Trustee" && (
            <footer>
              <p style={{ textAlign: "justify", marginTop: "40px" }}>
                Products are issued by LGIAsuper Trustee ABN 94 085 088 484 AFSL
                230511 as trustee for LGIAsuper ABN 23 053 121 564 RSE R1000160,
                trading as Brighter Super (Brighter Super). Insurance and/or
                administration services are provided to Brighter Super by TAL
                Life Limited ABN 70 050 109 450 AFSL 237848, which is part of
                the TAL Dai-ichi Life Australia (TAL) group of companies.
                Brighter Super is not part of the TAL Group and uses the Asteron
                Life brand under licence from TAL. The different entities of the
                Brighter Super Group and the TAL Group of companies do not
                guarantee, are not responsible for, or liable in respect of,
                products and services provided by the other.{" "}
              </p>
            </footer>
          )}
      </div>
    );
  }
}
